/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {DeadwoodRip} from "../DeadwoodRip";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";

export class DeadwoodRipNormalIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        DeadwoodRip.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
        });

        DeadwoodRip.xBetController.featureVisible = true;

        if(!DeadwoodRip.model.parsedGameData) {
            // game init idle.
            DeadwoodRip.idle.start();
            DeadwoodRip.shootingScreen.enabled = true;
            flowStateController.setSkipCallback(() => this.skip(flowStateController));
            return;
        }

        if(DeadwoodRip.model.gameData?.nextMode != GameMode.NORMAL) {
            flowStateController.finish();
            return;
        }

        //Because the tombstonerip has Gamble enabled, you won't see any win toggeling. It was decided during BookOfShadow that no toggeling should happen if there was gamble involved.
        //Though if you play the game with Norsktipping or Germany jurisdiction it will function as normal because at the moment ow writing this Gamble is not allowed in those jurisdictions.
        if(!BelowStakeWinRestriction.isWinBelowPlayedBetValue() && !DeadwoodRip.autoPlayPlugin.isAutoplayRound) {
            DeadwoodRip.individualWin.start();
        }

        if(!DeadwoodRip.autoPlayPlugin.isAutoplayRound) {
            DeadwoodRip.idle.start();
            DeadwoodRip.shootingScreen.enabled = true;
        }

        flowStateController.setSkipCallback(() => this.skip(flowStateController));
    }

    private async skip(flowStateController:FlowStateController):Promise<any> {
        await DeadwoodRip.individualWin.stop();
        flowStateController.finish();
    }
}